// extracted by mini-css-extract-plugin
export var auto = "_2w-1";
export var spinner = "_2w-0";